import { render, staticRenderFns } from "./PenalizareDialog.vue?vue&type=template&id=27fd094c&scoped=true"
import script from "./PenalizareDialog.vue?vue&type=script&lang=js"
export * from "./PenalizareDialog.vue?vue&type=script&lang=js"
import style0 from "./PenalizareDialog.vue?vue&type=style&index=0&id=27fd094c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fd094c",
  null
  
)

export default component.exports